import NotificationList from "@/components/notifications/NotificationList";
import { adminNotificationService } from "@/services/notificationService";

export default function AdminNotifications() {
  return <NotificationList title="Admin Notifications" service={adminNotificationService} testId="admin-notifications-list" />;
}
